<mat-sidenav-container>
  <!-- <mat-sidenav
    mode="side"
    opened
    class="print-no mat-sidenav"
    *ngIf="screenSize === 'desktop'"
  >
    <div class="logo">
      <a href="/">
        <img
          class="mini-logo-img"
          src="assets/images/mini-logo.png"
          height="50px"
          width="85px"
          alt="Logo"
        />
      </a>
    </div>

    <div class="footer grid-display-1">
      <button
        mat-stroked-button
        (click)="onTutorial()"
        *ngIf="showLogoutButton"
      >
        Need Help ?
      </button>

      <button
        mat-stroked-button
        (click)="onPrivacyPolicy()"
      >
        Privacy Policy
      </button>

      <button
        mat-stroked-button
        (click)="onTerms()"
      >
        Terms and Conditions
      </button>

      <button
        mat-stroked-button
        (click)="onLogout()"
        (keydown)="onLogoutKeydown($event)"
        *ngIf="showLogoutButton"
      >
        <span
          matTooltip="Logout"
          class="material-icons logout"
        >
          logout
        </span>

        &nbsp;&nbsp; Logout
      </button>
    </div>
  </mat-sidenav> -->

  <mat-sidenav-content class="sidenav-content print-yes">
    <ng-content select="[content]"></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
